import { ComponentProps, ComponentPropsWithoutRef, ForwardedRef, forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTaskDrawerState } from 'components/tasks/useTaskDrawerState';
import { twMerge } from 'tailwind-merge';

interface LinkedResourcePopoverRootProps extends ComponentPropsWithoutRef<'div'> {}
const LinkedResourcePopoverRoot = forwardRef(
    (
        { className, ...rest }: LinkedResourcePopoverRootProps,
        forwardedRef: ForwardedRef<HTMLDivElement>,
    ) => {
        return (
            <div
                ref={forwardedRef}
                className={twMerge(
                    'flex min-h-20 w-full min-w-80 max-w-80 flex-col gap-2 rounded-lg bg-white p-4',
                    className,
                )}
                {...rest}
            />
        );
    },
);

interface LinkedResourcePopoverHeaderProps extends ComponentPropsWithoutRef<'div'> {}
const LinkedResourcePopoverHeader = forwardRef(
    (
        { className, ...rest }: LinkedResourcePopoverHeaderProps,
        forwardedRef: ForwardedRef<HTMLDivElement>,
    ) => {
        return (
            <div
                ref={forwardedRef}
                className={twMerge(
                    'flex items-center gap-2 text-base font-medium leading-tight text-gray-900',
                    className,
                )}
                {...rest}
            />
        );
    },
);

interface LinkedResourcePopoverLinkProps extends ComponentProps<RouterLink> {}
const LinkedResourcePopoverLink = forwardRef(
    (
        { className, onClick, to, ...rest }: LinkedResourcePopoverLinkProps,
        forwardedRef: ForwardedRef<HTMLAnchorElement>,
    ) => {
        const { setIsDrawerOpen } = useTaskDrawerState();
        const closeDrawer = () => setIsDrawerOpen(false);

        return (
            <RouterLink
                ref={forwardedRef}
                to={to}
                className="font-medium"
                onClick={e => {
                    closeDrawer();
                    onClick?.(e);
                }}
                {...rest}
            />
        );
    },
);

interface LinkedResourcePopoverContentProps extends ComponentPropsWithoutRef<'div'> {}
const LinkedResourcePopoverContent = forwardRef(
    (
        { className, ...rest }: LinkedResourcePopoverContentProps,
        forwardedRef: ForwardedRef<HTMLDivElement>,
    ) => {
        return (
            <div
                ref={forwardedRef}
                className={twMerge('flex flex-col gap-2', className)}
                {...rest}
            />
        );
    },
);

const Root = LinkedResourcePopoverRoot;
const Header = LinkedResourcePopoverHeader;
const Link = LinkedResourcePopoverLink;
const Content = LinkedResourcePopoverContent;

export {
    LinkedResourcePopoverRoot,
    LinkedResourcePopoverHeader,
    LinkedResourcePopoverLink,
    LinkedResourcePopoverContent,
    //
    Root,
    Header,
    Link,
    Content,
};
